// @flow

import {
  onlyWhenSupport,
  type UserInputValidationError,
  type UserInputValidatorArgs,
  VALID,
} from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { validateSouthAfricanDocument } from './south-african-document';
import { validateSouthAfricanPhoneNumber, validateSouthAfricanPhoneNumberEmpty } from './south-african-phone-number';
import { validateSouthAfricanZipcode } from './south-african-zipcode';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = [];
  if (incomingPayment.status === 'OP') {
    optionalFields = getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec);
  }

  switch (userInputName) {
    case 'southAfricanDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_south_african_document') && validateSouthAfricanDocument(userInputValue);
      }
      return null;

    case 'southAfricanPhoneNumber': {
      if (hasOptionalField(optionalFields, 'telephone')) {
        return null;
      }
      const isCapitecPay = userInputValues['selectedEWallet'] === 'capitec-pay'
        && userInputValues['selectedPaymentMethod'] === 'ewallet';
      if (isCapitecPay) {
        return onlyWhen('field_south_african_phone_number') && validateSouthAfricanPhoneNumber(userInputValue);
      }
      return onlyWhen('field_south_african_phone_number') && validateSouthAfricanPhoneNumberEmpty(userInputValue);
    }

    case 'southAfricanZipcode':
      if (!hasOptionalField(optionalFields, 'zipcode')) {
        return onlyWhen('field_south_african_zipcode') && validateSouthAfricanZipcode(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
